import {modal} from '../modal-template/modal-template';

function handlePasswordReset() {
    console.log('handlePasswordReset');
    const path = window.location.pathname || '';

    const joinMatch = path.match(/^\/restore-password\/?$/);
    if (!joinMatch) return;

    // прочитаем profile из query до replaceState
    const urlParams = new URLSearchParams(window.location.search);
    const profile = urlParams.get('profile') || null;

    try {
        const newUrl = window.location.origin + '/';
        window.history.replaceState({}, document.title, newUrl);
    } catch (err) {
        // ignore
    }

    const params = {};
    if (profile) params.profile = profile;

    if (modal && typeof modal.open === 'function') {
        modal.open('restore-password', params);
    } else {
        document.addEventListener('modal-ready', function handler() {
            document.removeEventListener('modal-ready', handler);
            modal.open('restore-password', params);
        });
    }
}

document.addEventListener('DOMContentLoaded', function handler() {
    document.removeEventListener('DOMContentLoaded', handler);
    handlePasswordReset();
});
